<template>
  <div id="app">
    <water-mark :text="text" :gap="40" :font-size="18">
      <router-view/>
    </water-mark>
  </div>
</template>

<script>
import waterMark from "@/components/waterMark";
export default {
  name: 'App',
  components: {
    waterMark
  },
  data() {
    return {
      text: "中国人寿养老保险股份有限公司"
    };
  },
}
</script>

<style>
#app {
  position: relative;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.el-dialog{
  border-radius: 6px;
}
.el-dialog__header{
  border-bottom: 1px solid #E8EAEB;
}
::-webkit-scrollbar{
	width: 5px;/*竖向滚动条的宽度*/
	height: 5px;/*横向滚动条的高度*/
}
::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
	background: #B2B9C9;
}
::-webkit-scrollbar-track{/*滚动条轨道的样式*/
	background: #EEF0F1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue